<template>
	<vx-card :title="$t('Follower.SelectNotificationChanel')">
		<p>
			{{ $t("Follower.SelectNotificationChanelText") }}
		</p>

		<ul class="demo-alignment" id="notification-chanel-settings">
			<li v-if="followersConfig.exist && followersConfig.config.sms">
				<vs-checkbox v-model="checkBoxSMS">{{ $t("Follower.Sms") }}</vs-checkbox>
			</li>

			<li v-if="followersConfig.exist && followersConfig.config.email">
				<vs-checkbox v-model="checkBoxEmail">{{ $t("Follower.Email") }}</vs-checkbox>
			</li>

			<li v-if="followersConfig.exist && followersConfig.config.whatsapp">
				<vs-checkbox v-model="checkBoxWhatsApp">{{ $t("Follower.WhatsApp") }}</vs-checkbox>
			</li>
		</ul>

		<vs-divider></vs-divider>

		<div v-if="followersConfig.exist">
			<p>
				{{ $t("Follower.SelectNotificationChanelText2") }}
			</p>

			<ul class="flex flex-col gap-2 mt-4" id="in_event_status-settings">
				<li v-for="status in eventStatus">
					<vs-checkbox v-model="checkBoxStatus" :vs-value="status.value">{{ status.label }}</vs-checkbox>
				</li>
			</ul>
		</div>

		<vs-alert icon-pack="feather" icon="icon-info" color="danger" :active="!followersConfig.exist" class="mt-4">
			{{
				$t("Follower.ConfigCompanyRequired", {
					id: $t("Follower.Followers").toUpperCase(),
				})
			}}
		</vs-alert>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";

export default {
	name: "FollowerFormChanel",
	components: {
		// component components
		vSelect,
	},
	props: {
		follower: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			checkBoxSMS: this.follower.sms,
			checkBoxEmail: this.follower.to_email,
			checkBoxWhatsApp: this.follower.whatsapp,
			checkBoxStatus: this.follower.in_event_status,
		};
	},
	computed: {
		eventStatus() {
			return [
				{label: this.$t("Schedule.Scheduled"), value: "ASSIGNED"},
				{label: this.$t("Schedule.ReProgramming"), value: "RESCHEDULED"},
				{label: this.$t("Schedule.Delayed"), value: "DELAYED"},
				{label: this.$t("Schedule.OnTheWay"), value: "ON THE WAY"},
				{label: this.$t("Schedule.InProgress"), value: "IN PROGRESS"},
				{label: this.$t("Schedule.Finished"), value: "FINALIZED"},
				{label: this.$t("Schedule.Canceled"), value: "CANCELLED"},
				{label: this.$t("Schedule.NotAssigned"), value: "NOT ASSIGNED"},
			];
		},

		followersConfig() {
			return this.$store.getters["moduleCompanyConfig/getFollowersConfig"];
		},
	},

	watch: {
		// component watchers
		checkBoxEmail(val) {
			this.$emit("update", "to_email", val);
		},
		checkBoxSMS(val) {
			this.$emit("update", "sms", val);
		},
		checkBoxWhatsApp(val) {
			this.$emit("update", "whatsapp", val);
		},
		checkBoxStatus(val) {
			this.$emit("update", "in_event_status", val);
		},
		follower(val) {
			this.checkBoxSMS = val.sms;
			this.checkBoxEmail = val.to_email;
			this.checkBoxWhatsApp = val.whatsapp;
			this.checkBoxStatus = [...val.in_event_status];
		},
	},
};
</script>

<style scoped>
/* component styles */
</style>
